<template>
  <div class="home-notice" :class="{'is-loading': loading}" v-if="loading || (notices && notices.length > 0)">
    <div class="loading-container" v-if="loading">
      <i class="loading-icon"></i>
    </div>
    <template v-else>
      <div class="notice-header">
        <h4 class="notice-title">最新通知</h4>
        <a class="notice-more" @click="goMore">查看更多 &gt;&gt;</a>
      </div>
      <ul class="notice-list">
        <li v-for="item in notices" :key="item.noticeId" class="notice-item" @click="goDetail(item.noticeId)">
          <span class="notice-dot"></span>
          <span class="notice-text">{{item.title}}</span>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
export default {
  name: 'HomeNotice',
  props: {
    notices: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['more'],
  methods: {
    goDetail (noticeId) {
      if (!noticeId) return
      this.$router.push({
        name: 'NoticeInfo',
        params: {
          target: this.$store.state.sessionTarget,
          id: noticeId
        }
      })
    },
    goMore () {
      this.$emit('more')
      this.$router.push({
        name: 'NoticeList',
        params: {
          target: this.$store.state.sessionTarget
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.home-notice {
  padding: 12px 16px;
  min-width: 200px;

  &.is-loading {
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .loading-container {
    text-align: center;
    .loading-icon {
      display: inline-block;
      background: url(../assets/img/loading.gif) no-repeat;
      background-size: 100%;
      width: 40px;
      height: 40px;
    }
  }

  .notice-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;

    .notice-title {
      font-size: 16px;
      font-weight: 600;
      color: #333;
      margin: 0;
    }

    .notice-more {
      font-size: 12px;
      color: #157DF9;
      cursor: pointer;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .notice-list {
    list-style: none;
    margin: 0;
    padding: 0;

    .notice-item {
      display: flex;
      align-items: center;
      padding: 6px 0;
      cursor: pointer;
      transition: color 0.15s;

      &:hover {
        color: #FD3374;
      }

      .notice-dot {
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background: #999;
        margin-right: 8px;
        flex-shrink: 0;
      }

      .notice-text {
        font-size: 13px;
        color: #666;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 15em;
      }
    }
  }
}
</style>
